module.exports = __webpack_public_path__ + "static/media/program_step_3bis_fr.82adfa47.svg";